<div class="app-input" *ngIf="visible | async; let isVisible">
  <mat-checkbox *ngIf="field.conditionallyEnabled" color="primary" [checked]="field.checked"
                (change)="changeStatus($event)">&nbsp;&nbsp;
  </mat-checkbox>
  <mat-form-field [formGroup]="group"
                  [class]="field.conditionallyEnabled?'with-checkbox-field':'full-width-field'">
    <mat-label>{{ field.displayName }}</mat-label>
    <input matInput [formControlName]="field.name" [placeholder]="field.displayName || ''"
           [type]="field.inputType || ''" [readonly]="!field.enabled">
    <mat-hint ng-if="field.hint">{{ field.hint }}</mat-hint>
    @for (validation of field.validations; track validation) {
      <mat-error
        *ngIf="group.controls[field.name].hasError(validation.name.toLowerCase())">{{ validation.message }}
      </mat-error>
    }
  </mat-form-field>
  <button type="button" mat-icon-button color="primary" aria-label="advanced search" matTooltip="Advanced search" (click)="openDialog()">
    <mat-icon>contacts</mat-icon>
  </button>
</div>
